<ng-container *ngIf="placement === 'sidebar'">
  <div class="claim-sidebar">
    <h2 class="title">{{ "REPORT_A_CLAIM" | translate }}</h2>
  </div>
  <div class="d-flex pt-2 claim-sidebar">
    <img src="./assets/img/images/icon-audit.svg" alt="audit icon" />
    <div>
      <div class="report-phone mb-2">
        {{ "PHONE" | translate }}:
        <ng-container *ngIf="isAcmic; else MAstate">
          <a class="underline" href="tel:18442954500">1-844-295-4500</a>
        </ng-container>
        <ng-template #MAstate>
          <a class="mapfre link red-link underline" href="tel:18556273737">1-855-627-3737</a>
        </ng-template>
        <br />
        <div class="mt8">{{ "WE_ARE_HERE_FOR_YOU" | translate }}</div>
      </div>
      <app-claim-modal *ngIf="policies && policies.length > 1" [policies]="policies">
      </app-claim-modal>
      <div *ngIf="policies && policies.length === 1">
        <a class="btn mapfre ghost primary a-h24 x-small-btn waves-effect sendDocBtn"
          href="" (click)="reportClaim(policies[0], $event)">
          <span>{{ "REPORT_A_CLAIM" | translate }}</span>
        </a>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="placement === 'noclaims'">
  <div class="report-sec">
    <div class="mb-3"><img src="./assets/img/images/icon-audit.svg" alt="audit icon" /></div>
    <div class="report-btn-sec w-100-mobile">
      <div class="need-to-file mb-2">
        {{ "Need to file a claim?" | translate }}
      </div>
      <div [ngClass]="{'w-100-mobile claim-mobile-btn':!isAcmic}">
        <div>
          <app-claim-modal *ngIf="
              policies && policies.length > 1;
              else directLinkToReportClaim
            " [policies]="policies">
          </app-claim-modal>
          <ng-template #directLinkToReportClaim>
            <a class="btn mapfre ghost primary a-h24 x-small-btn waves-effect sendDocBtn"
              href="" (click)="reportClaim(policies[0], $event)">
              <span>{{ "REPORT_A_CLAIM" | translate }}</span>
            </a>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="sendDocBox" [ngClass]="{ 'pl-2': isAcmic }">
      <p class="sendDocTxt">
        <span class="callus">{{ "CALL_US" | translate }}</span>
        <ng-container *ngIf="isAcmic; else MAstate">
          <a class="underline" href="tel:18442954500">1-844-295-4500</a>
        </ng-container>
        <ng-template #MAstate>
          <a class="dm-sans-medium font-size medium-font mapfre link red-link underline"
            href="tel:18556273737">1-855-627-3737</a>
        </ng-template>
        <br />
      </p>
    </div>
  </div>
</ng-container>